import * as React from 'react';
const SvgCorporate = (props) => (
  <svg viewBox="0 0 124 124" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M62 122c33.137 0 60-26.863 60-60S95.137 2 62 2 2 28.863 2 62s26.863 60 60 60Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M46.516 52.323c7.483 0 13.549-6.066 13.549-13.549 0-7.482-6.066-13.548-13.549-13.548-7.482 0-13.548 6.066-13.548 13.548 0 7.483 6.066 13.549 13.548 13.549ZM40.71 72.98a13.49 13.49 0 0 1 5.806-1.303c7.48 0 13.549 6.068 13.549 13.549 0 7.48-6.068 13.548-13.549 13.548-7.48 0-13.548-6.067-13.548-13.548M89.097 75.548c7.482 0 13.548-6.065 13.548-13.548s-6.066-13.548-13.548-13.548c-7.483 0-13.549 6.066-13.549 13.548 0 7.483 6.066 13.548 13.549 13.548Z"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M44.227 52.114c-.285 5.923-.096 12.46.712 19.66M50.116 98.276c1.05 3.89 2.27 7.926 3.648 12.111M49.603 25.594c5.158-13.07 12.682-20.202 16.921-23.405M34.047 33.47c-9.266-2.805-16.897-4.518-21.498-5.438M100.235 69.698c5.43 5.004 12.325 10.553 16.573 16.704M70.134 48.452c2.647 1.596 5.337 3.305 8.361 5.129M77.087 68.261c-5.41 3.416-11.845 7.737-17.995 11.942M101.997 57.868c5.632-1.786 13.403-3.233 19.398-4.302M38.527 96.152a237.032 237.032 0 0 0-13.684 12.938"
      stroke="#000"
      strokeWidth={4}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
export default SvgCorporate;
